import {
  postWithNoToken,
  postLogin,
  get,
  put
} from '../configApi'

export async function checkCompany(body) {
  return await postWithNoToken(`/account/tula/login/company`, body)
}

export async function login(body) {
  return await postLogin(`/account/tula/login/admin`, body)
}

export async function getInfo() {
  return await get(`/account/tula/info/admin`)
}

export async function getTotalRequest() {
  return await get(`/mylib/request/total`)
}

export async function logout(body) {
  return await put(`/account/logout`, body)
}

export async function loginSuperAdmin(body) {
  return await postLogin(`/account/tula/login/supperadmin`, body)
}